import React, { Component } from 'react'
import {Link} from 'gatsby'
import abstractMenu from './abstractMenu'
class ProstateMenu extends Component {
  render(){
    if(!this.props.mobile){
      return (
        <li className="tulsa-menu" onMouseOver={() => {
            this.props.setMenu({menu: true}, ()=> {
                document.addEventListener('click', this.props.hideDropdownMenu)
            })
        }} onMouseOut={() => {
            this.props.setMenu({menu: false})
        }} ><Link to="/prostate-101">Prostate 101</Link>
          <ul className={`tulsa-inner-menu ${this.props.menu ? 'show': 'hide'}`} onMouseOut={() => {
              this.props.setMenu({menu: false})
          }}>
             <li><Link className="button" to="/prostate-101/">Prostate Cancer</Link></li>
             <li><Link className="button" to="/prostate-101/benign-prostate-disease/">Benign Prostate Disease</Link></li>
             <li><Link className="button" to="/prostate-101/psa-test/">PSA Test</Link></li>
          </ul>
        </li>
      )
    }else {
      return (
        <li><a href='#' onClick={e => {
            e.preventDefault()
            this.props.setMenu({menu: true}, ()=> {
                document.addEventListener('click', this.props.hideDropdownMenu)
            })
        }}>Prostate 101</a>
          <ul className={`${this.props.menu ? 'show': 'hide'}`} >
             <li><Link className="button" to="/prostate-101/">Prostate Cancer</Link></li>
             <li><Link className="button" to="/prostate-101/benign-prostate-disease/">Benign Prostate Disease</Link></li>
             <li><Link className="button" to="/prostate-101/psa-test/">PSA Test</Link></li>
          </ul>
        </li>
      )
    }
  }
}
export default abstractMenu(ProstateMenu)
